import React from "react"
import classnames from "classnames"

export default function Input({
  type,
  value,
  onChange,
  className,
  multiline,
  label,
  id,
  disabled,
  ...props
}) {
  return (
    <div
      className={classnames(
        "flex flex-col",
        disabled && "cursor-not-allowed",
        className
      )}
    >
      {/*
        ESLint fails to notice the htmlFor that's being passed for some reason
        So, we ignore it's nagging.
       */}
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label
        className="text-base lg:text-body-18 text-black mb-2"
        htmlFor={id ?? `input-${label}`}
      >
        {label}
      </label>
      {!multiline && (
        <input
          id={id ?? `input-${label}`}
          className={classnames(
            "rounded p-4 flex items-center bg-primary bg-opacity-10",
            disabled && "cursor-not-allowed"
          )}
          type={type}
          value={value}
          onChange={onChange}
          disabled={disabled}
          {...props}
        />
      )}
      {multiline && (
        <textarea
          id={id ?? `input-${label}`}
          className={classnames(
            "rounded p-4 bg-primary bg-opacity-10 resize-none",
            disabled && "cursor-not-allowed"
          )}
          rows={8}
          onChange={onChange}
          value={value}
          disabled={disabled}
          {...props}
        />
      )}
    </div>
  )
}

Input.defaultProps = {
  type: "text",
  disabled: false,
}
